export default "__VITE_ASSET__bXVXPpUA__"